import { AbstractsService, GetAbstractsResponse } from "@/client";
import { HttpError } from "@/types/error";
import {
  UseQueryOptions,
  keepPreviousData,
  useQuery,
} from "@tanstack/react-query";

const abstractsQueryKey = (
  congressId: string,
  pageSize = 10,
  pageIndex = 0,
  search?: string,
  sortBy?: "rating" | "ratingCount" | "createdAt",
  sortOrder?: "asc" | "desc",
) => {
  return [
    "abstracts",
    congressId,
    pageSize,
    pageIndex,
    search,
    sortBy,
    sortOrder,
  ] as const;
};

function useGetAbstracts(
  {
    congressId,
    pageSize = 10,
    pageIndex = 0,
    search,
    sortBy,
    sortOrder,
  }: {
    congressId: string;
    pageSize?: number;
    pageIndex?: number;
    search?: string;
    sortBy?: "rating" | "ratingCount" | "createdAt";
    sortOrder?: "asc" | "desc";
  },
  queryOptions?: Partial<UseQueryOptions<GetAbstractsResponse, HttpError>>,
) {
  const offset = pageIndex * pageSize;

  return useQuery({
    queryKey: abstractsQueryKey(
      congressId,
      pageSize,
      pageIndex,
      search,
      sortBy,
      sortOrder,
    ),
    queryFn: () =>
      AbstractsService.getAbstracts({
        congressId,
        limit: pageSize,
        offset,
        search,
        sortBy,
        sortOrder,
      }),
    placeholderData: keepPreviousData,
    ...queryOptions,
  });
}

export { abstractsQueryKey, useGetAbstracts };
